import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CalendarModule,
  DataTableModule,
  ListboxModule,
  MultiSelectModule,
  StepsModule,
  MenuModule,
  GrowlModule,
  MessagesModule,
  AutoCompleteModule,
  DropdownModule,
  EditorModule,
  InputTextModule,
  ChipsModule,
  DialogModule,
  TooltipModule,
  FieldsetModule
} from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HomeService } from './home.service';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    BrowserAnimationsModule,
    DataTableModule,
    ListboxModule,
    MultiSelectModule,
    StepsModule,
    MenuModule,
    GrowlModule,
    MessagesModule,
    AutoCompleteModule,
    DropdownModule,
    EditorModule,
    InputTextModule,
    ChipsModule,
    DialogModule,
    TooltipModule,
    HomeRoutingModule,
    FieldsetModule,
  ],
  declarations: [
  ],
  providers: [ HomeService ],
  bootstrap: [HomeComponent]
})
export class HomeModule {}
